import moment from "moment";

export const getCount = (id) => {
  if (id == 1) return 3;
  if (id == 2) return 4;
  if (id == 3) return 5;
  if (id == 4) return 7;
  if (id == 5) return 10;
};

export const FormStatus = {
  OPEN: "Open",
  OPENDRAFT: "Draft",
  DUESOON: "Due soon",
  OVERDUE: "Over due",
  CLOSED: "Closed",
  RELEASE: "Released",
  SUBMIT: "Submitted",
};

export const getStatus = (data) => {
  if (data) {
    const priordate =
      data &&
      data.actualclosedate &&
      moment(data.actualclosedate, "YYYY-MM-DD HH:mm:ss")
        .subtract("days", 2)
        .format("YYYY-MM-DD");
    const actualclosedate =
      data &&
      data.actualclosedate &&
      moment(data.actualclosedate, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
    const enddate =
      data &&
      data.closedate &&
      moment(data.closedate, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
    const today = moment(new Date()).format("YYYY-MM-DD");
    const opendate =
      data &&
      data.opendate &&
      moment(data.opendate, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
    return data.formstatusid == 3
      ? FormStatus.SUBMIT
      : data.formstatusid == 4
      ? FormStatus.RELEASE
      : data.formstatusid == 1 && today >= opendate && today < priordate
      ? FormStatus.OPEN
      : data.formstatusid == 2 && today >= opendate && today < priordate
      ? FormStatus.OPENDRAFT
      : (data.formstatusid == 1 || data.formstatusid == 2) &&
        today >= priordate &&
        today <= actualclosedate
      ? FormStatus.DUESOON
      : (data.formstatusid == 1 || data.formstatusid == 2) &&
        today > actualclosedate &&
        today <= enddate
      ? FormStatus.OVERDUE
      : FormStatus.CLOSED;
  }
};

export const getPartiCipant = (id) => {
  console.log(id);
  if (id) {
    return id == 1
      ? "As self employee"
      : id == 2
      ? "As Manager"
      : id == 3
      ? "As direct reportee"
      : id == 4
      ? "As co-worker"
      : id == 5
      ? "As external"
      : "";
  } else {
    return "";
  }
};

export const GetNumberOfEmp = (count) => {
  if (count >= 3) {
    return count - 3;
  }
  return 0;
};
